import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererDraftApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getDraft = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}`);
        };
        this.createDraft = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/themes`, requestBody);
        };
        this.publishDraft = (pathParams) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/publish`);
        };
        this.getThemeSettings = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/settings`);
        };
        this.getSection = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/sections/${pathParams.section_key}`);
        };
        this.updateThemeSettings = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/settings`, requestBody);
        };
        this.updateThemeBranding = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}`, requestBody);
        };
        this.getLayout = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/layouts/${pathParams.library_page_name}`);
        };
        this.getLayoutCustomPage = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/layouts/custom_pages/${pathParams.shop_page_id}`);
        };
        this.updateSectionSettings = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/sections/${pathParams.draft_section_id}/settings`, requestBody);
        };
        this.createSection = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/sections`, requestBody);
        };
        this.removeSection = (pathParams) => {
            return this.delete(`/shops/${pathParams.shop_id}/drafts/sections/${pathParams.draft_section_id}`);
        };
        this.updateSectionOrder = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/sections/${pathParams.draft_section_id}/reorder`, requestBody);
        };
        this.getSectionSchema = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/section_schemas/draft_sections/${pathParams.section_id}`);
        };
        this.getSectionSchemas = (pathParams, queryParams) => {
            return this.get(`/shops/${pathParams.shop_id}/section_schemas/draft_themes/${pathParams.draft_theme_id}`, queryParams);
        };
        this.updateSection = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/sections/${pathParams.draft_section_id}`, requestBody);
        };
        this.disablePageTemplates = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/theme_page_templates/disable`, requestBody);
        };
        this.enablePageTemplates = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/theme_page_templates/enable`, requestBody);
        };
    }
}
export const ShopRendererDraftApiClient = new ShopRendererDraftApiClientModel(getShopRendererApiUrl('api'));
